// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggle {
   margin: 2px 10px 5px 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/e-form/form-generate/field-type/toggle/toggle.component.css"],"names":[],"mappings":"AAAA;GACG,yBAAyB;AAC5B","sourcesContent":[".toggle {\n   margin: 2px 10px 5px 12px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
